import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import AdServerAccessUpdateForm from './AdServerAccessUpdateForm'
import AdServerAccessCreateForm from './AdServerAccessCreateForm'
import AdServerFormSkeleton from './AdServerFormSkeleton'

import { getAdServerList } from '../../../../modules/actions/adServer'
import {
  adServerListErrorSelector,
  adServerListSelector,
  adServerListWasLoadedSelector
} from '../../../../modules/selectors/adServer'
import { selectedPartnershipRightsHolderIdSelector } from '../../../../modules/selectors/partnerships'

function AdServerAccessForm() {
  const dispatch = useDispatch()

  const adServerList = useSelector(adServerListSelector)
  const adServerListWasLoaded = useSelector(adServerListWasLoadedSelector)
  const adServerListError = useSelector(adServerListErrorSelector)

  const selectedPartnershipRightsHolderId = useSelector(selectedPartnershipRightsHolderIdSelector)

  const rightHolderAdServer = useMemo(
    () => adServerList.find(adServer => adServer.account === selectedPartnershipRightsHolderId),
    [adServerList, selectedPartnershipRightsHolderId]
  )

  useEffect(() => {
    dispatch(getAdServerList())
  }, [dispatch])

  if (!adServerListWasLoaded && !adServerListError) {
    return <AdServerFormSkeleton />
  }

  if (rightHolderAdServer) {
    return <AdServerAccessUpdateForm rightHolderAdServer={rightHolderAdServer} />
  } else {
    return <AdServerAccessCreateForm />
  }
}

export default AdServerAccessForm
